import { initIndustriesSliderCarousel } from '@components/sliders/sliders'

document.addEventListener('DOMContentLoaded', () => {
  initIndustriesSliderCarousel()
}, { once: true })
